import hateoas from 'viralstyle-ui/src/hateoas';
import storage from 'viralstyle-ui/src/storage';
import requestService from 'viralstyle-ui/src/requestService';

import config from 'config';

class BaseApiService {
  getCurrentUserId() {
    return requestService.get(hateoas.url('get_logged_in_client'));
  }

  getCurrentUserDetails() {
    return requestService.get(hateoas.url('client_details', { clientId: storage.get('client-hash') }));
  }
}

export default new BaseApiService();